import { getMutatedWhereClauseWithL1Values } from 'v2/core/repository/eql/getMutatedWhereClauseWithL1Values';
import { getMutatedWhereClauseWithCategories } from 'v2/core/repository/eql/getWhereClauseHavingCategories';
import { EQLProps } from './types';

export const mutateEQLPropsMaybe = (eqlProps: EQLProps): EQLProps => {
  const mutatedEqlProps = { ...eqlProps };

  if (mutatedEqlProps.whereClause) {
    mutatedEqlProps.whereClause = getMutatedWhereClauseWithCategories(
      mutatedEqlProps.whereClause,
    );

    mutatedEqlProps.whereClause = getMutatedWhereClauseWithL1Values(
      mutatedEqlProps.whereClause,
    );
  }

  if (
    mutatedEqlProps.delta?.type === 'whereClause' &&
    mutatedEqlProps.delta.value
  ) {
    mutatedEqlProps.delta.value = getMutatedWhereClauseWithCategories(
      mutatedEqlProps.delta.value,
    );
    mutatedEqlProps.delta.value = getMutatedWhereClauseWithL1Values(
      mutatedEqlProps.delta.value,
    );
  }

  return mutatedEqlProps;
};
